import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  advisor:null,//TODO - bring is from server -46EE10AB-FBE9-EB11-BACB-000D3AB994CF
  coordinator:null,//TODO - NULL
  committee: null,
  committees: [],
};

const advisorSlice = createSlice({
  name: "advisor",
  initialState,
  reducers: {
    setAdvisor:(state, { payload }) => {
      state.advisor = payload;
    },
    setIsCoordinator:(state, { payload }) => {
      state.coordinator = payload;
    },
    setCommittee: (state, { payload }) => {
      state.committee = payload;
    },
    setCommittees: (state, { payload }) => {
      state.committees = payload;
    },
  },
});
const { actions, reducer } = advisorSlice;

export const { setCommittee, setCommittees, setAdvisor, setIsCoordinator } = actions;
export default reducer;

// selectors
export const advisorSelector = (state) => state.advisor.advisor;
export const isCoordinatorSelector = (state) => state.advisor.coordinator;
export const committeeSelector = (state) => state.advisor.committee;
export const committeesSelector = (state) => state.advisor.committees;
